import _objectSpread from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { AccountStorage, Account } from "@services/account";
import { HeadeSearch } from "@components/head-search";
import { PageFooter } from "@components/page-footer";
import { PageTop } from "@components/page-top";
var account = new Account();
var accountStorage = new AccountStorage();
// 结算商品数据
var cartOrderList = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/cartOrderList";
// 收货地址列表
var addressList = "/pjyy-deepexi-user-center/api/v1/address/addressList";
// 设置默认收货地址
var setAddressDefault = "/pjyy-deepexi-user-center/api/v1/address/setDefault";
// 发票抬头列表
var invoiceList = "/pjyy-deepexi-user-center/api/v1/invoice/invoiceList";
// 获取运费
var orderFrank = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/OrderFrank";
// 获取配送方式
var distributionWay = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/distributionWay";
// 提交订单
var saveOrder = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/saveOrder";
// 获取支付方式
var validTypeList = "/pjyy-deepexi-pay-center/api/v1/channel/validTypeList";
// 获取代客下单的客户
var _getInfoList = "/pjyy-deepexi-user-center/api/v1/company/getInfoList";
// 新增缓存
var _savePreOrder = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/savePreOrder";
// 查询缓存
var _findPreOrder = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/findPreOrder/1";
// 查询创建订单进度
var orderProgress = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/orderProgress";
// 取消销售单
var scrapSalesOrder = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/scrapSalesOrder/";
var timer;
var orderTimer;
export default {
  components: {
    HeadeSearch: HeadeSearch,
    PageFooter: PageFooter,
    PageTop: PageTop
  },
  data: function data() {
    return {
      redpage: 0,
      isuse: false,
      showtx: false,
      isLogin: false,
      companyNmae: "",
      payKey: "",
      //支付方式
      giveKey: "",
      //配送方式
      imageAndList: true,
      //图文和列表切换显示
      invoiceForm: {
        invoiceTitle: null,
        //发票抬头
        num: "",
        //纳税人识别号
        invoiceType: 1,
        //开票方式
        remarks: ""
      },
      isInvoice: false,
      //是否开票
      isMore: false,
      shoppList: [],
      // 商品数据
      lstPayType: [],
      giveList: [],
      addressList: [],
      //收货地址
      invoiceList: [],
      totalForm: {
        productNum: "",
        total: "",
        fullReduction: "",
        //满减
        freight: "",
        //运费
        allTotal: "",
        rebateMoney: "",
        cashAmount: "",
        ticketDiscount: "",
        onlinePaymentInstantDiscount: "" //线上支付优惠
      },
      freightNum: 0,
      //运费
      addressId: null,
      //收货地址id
      userIdentity: 1,
      //用户身份（1普通用户  2供应商）
      // 代客下单信息
      userInfo: {
        name: "",
        num: "",
        address: "",
        userId: ""
      },
      userContent: {},
      userList: [],
      preuuid: "",
      disSubmit: false,
      isShowInfoList: false,
      userName: "",
      total: 2,
      current: 1,
      // 页码
      perPage: 20,
      rangeBefore: 3,
      rangeAfter: 1,
      isBalance: false,
      isBalanceFlag: false,
      balanceAmount: 0,
      balanceMsg: "",
      isgivePhone: false,
      givePhone: 0,
      totalBalanceAmountdd: 0,
      orderProgress: false,
      //进度条弹窗
      isErrorShow: false,
      //异常提示框
      errorBox: true,
      orderPercent: 3,
      //进度值
      errorData: {},
      //异常数据
      orderErrorMsg: "",
      //异常提示信息
      isShowprogress: false,
      nums: 0,
      //定时请求次数
      isComplete: false,
      //是否到达30次
      uniqueToken: '',
      isMeet: true,
      //托运客户是否满足500
      isMeetTwo: false,
      //托运客户是否满足500，是否含有异常商品
      onlinePaymentPercentage: null,
      //线上支付返利比例
      maxlimitAmt: null,
      //线上支付立减优惠金额超过最高比例
      whetherCashCustomer: false,
      //现金客户提示
      userArrears: false,
      //欠款提示
      arrearsData: {},
      //欠款信息
      useCoupon: true,
      //优惠券是否使用
      checkCouponStatus: null,
      //是否参与优惠券
      couponCurrentDeductionPrice: 0,
      //优惠券当前优惠金额
      couponNextDeductionPrice: 0,
      //优惠券下一级优惠金额
      couponNeedAddPrice: 0,
      //参与下一级优惠金额补充金额
      couponId: null,
      //优惠券id
      couponType: 0,
      //优惠券类型
      couponEndTime: null //优惠券过期时间
    };
  },
  created: function created() {
    this.isLogin = account.isLogined();
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.uniqueToken = _this.guid(20);
            _this.getDistributionMode();
            _this.getNum();
            _this.findPreOrder().then(function () {
              if (_this.userIdentity === 1) {
                var companyId = accountStorage.getCacheUserInfo().loginCompanyId;
                _this.getPayType(companyId);
              }
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  filters: {
    unit: function unit(type) {
      var a = type.indexOf("*");
      var num = type.substring(1, a) * type.substring(a + 1, type.length - 1);
      return num;
    }
  },
  methods: {
    getOnlinePay: function getOnlinePay() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.payType === "ONLINE") {
            return item;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    //立即还款
    nowArrears: function nowArrears() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var account, URL, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              account = accountStorage.getCacheUserInfo().account;
              URL = "/pjyy-deepexi-erp-api-center/api/v1/erp/orderBill/getOrdersAndLike/".concat(account);
              _context2.next = 4;
              return _this2.$getHttpClient().get(URL);
            case 4:
              result = _context2.sent;
              if (result.data.code == 200) {
                window.open(result.data.data);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    pullOnlinePay: function pullOnlinePay() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var URL, params, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              URL = "/pjyy-deepexi-pay-center/api/v1/channel/validList";
              params = {
                payType: "ONLINE"
              };
              _context3.next = 4;
              return _this3.$getHttpClient().get(URL, {
                params: params
              });
            case 4:
              response = _context3.sent;
              if (!(response.data.code === "200")) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", response.data.data);
            case 7:
              return _context3.abrupt("return", []);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getNum: function getNum() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$getHttpClient().get(
              // "/pjyy-deepexi-user-center/api/v1/balance/getCurrentMonthStatistics"
              "/pjyy-deepexi-user-center/api/v1/balance/getMonthStatistics");
            case 2:
              result = _context4.sent;
              if (result.data.code === "200") {
                _this4.totalBalanceAmountdd = result.data.data.totalBalanceAmount || 0;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // setgivePhone(val){
    //   if(val){
    //     this.givePhone = 1
    //   }else{
    //     this.givePhone = 0
    //   }
    // },
    //是否勾选红包
    isBalanceChange: function isBalanceChange(e) {
      if (e) {
        this.savePreOrder(1);
      } else {
        this.savePreOrder(2);
      }
    },
    //是否使用优惠券
    isCouponChange: function isCouponChange(e) {
      if (e) {
        this.savePreOrder();
      } else {
        this.$buefy.toast.open({
          message: "您有" + this.couponCurrentDeductionPrice + "元优惠券将在" + this.couponEndTime + "后过期",
          type: "is-danger"
        });
        this.savePreOrder();
      }
    },
    // 收货地址，支付方式，配送方式，发票信息存缓存
    savePreOrder: function savePreOrder(val) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                addressInfoId: _this5.addressId,
                invoiceInfoId: _this5.invoiceForm.invoiceTitle,
                invoiceRemark: _this5.invoiceForm.remarks,
                invoice: _this5.invoiceForm.num,
                payType: _this5.payKey,
                totalMoney: _this5.totalForm.allTotal,
                distributionWay: _this5.giveKey,
                freight: _this5.totalForm.freight,
                preuuid: _this5.$route.params.id,
                useCoupon: _this5.useCoupon ? 1 : 2
              };
              if (val) {
                data.useRedPackets = val;
              }
              _context5.next = 4;
              return _this5.$getHttpClient().post(_savePreOrder, data);
            case 4:
              result = _context5.sent;
              if (!(result.data.code === "200")) {
                _context5.next = 8;
                break;
              }
              _this5.findPreOrder();
              return _context5.abrupt("return", result.data.data);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 查询缓存
    findPreOrder: function findPreOrder() {
      var _this6 = this;
      var id = this.$route.params.id;
      return this.$getHttpClient().get("".concat(_findPreOrder, "?preuuid=").concat(id)).then(function (res) {
        if (res.data.code === "200") {
          _this6.addressId = Number(res.data.data.addressInfoId);
          // this.payKey = res.data.data.payType;
          // 支付方式
          if (res.data.data.payType) {
            _this6.payKey = res.data.data.payType;
          }
          // 配送方式
          if (res.data.data.distributionWay) {
            _this6.giveKey = res.data.data.distributionWay;
          }
          // this.giveKey = res.data.data.distributionWay;
          // if (!this.giveKey) {
          //   this.giveKey = this.giveList[0].key;
          // }
          _this6.invoiceForm.invoiceTitle = res.data.data.invoiceInfoId;
          _this6.invoiceForm.remarks = res.data.data.invoiceRemark;
          _this6.invoiceForm.num = res.data.data.invoice;
          // 如果发票有信息，默认勾中
          if (_this6.invoiceForm.invoiceTitle) {
            _this6.isInvoice = true;
          }
          var arr = res.data.data.orderLineVoList || [];
          _this6.shoppList = arr;
          _this6.totalForm.total = res.data.data.sumMoney;
          _this6.totalForm.fullReduction = res.data.data.reducedPriceTotal; // 满减
          _this6.totalForm.allTotal = res.data.data.totalMoney;
          _this6.totalForm.productNum = res.data.data.totalNumber;
          _this6.totalForm.freight = res.data.data.freight; // 运费
          _this6.totalForm.rebateMoney = res.data.data.rebateMoney; // 运费
          _this6.totalForm.cashAmount = res.data.data.cashAmount;
          _this6.totalForm.ticketDiscount = res.data.data.ticketDiscount;
          _this6.totalForm.onlinePaymentInstantDiscount = res.data.data.onlinePaymentInstantDiscount; //线上支付返利金额
          _this6.onlinePaymentPercentage = res.data.data.onlinePaymentPercentage; //线上支付返利比例
          _this6.whetherCashCustomer = res.data.data.whetherCashCustomer; //现金客户提示
          _this6.maxlimitAmt = res.data.data.maxlimitAmt; //线上支付立减优惠金额超过最高比例
          _this6.balanceAmount = res.data.data.balanceAmount;
          _this6.isBalance = res.data.data.useRedPackets == 1 ? true : false;
          _this6.userIdentity = res.data.data.userType;
          _this6.redpage = res.data.data.redPacket;
          _this6.useCoupon = res.data.data.useCoupon == 1 ? true : false; //优惠券1使用 2不使用
          _this6.checkCouponStatus = res.data.data.checkCouponStatus; //是否参与优惠券0不可以参加1可以参加，为空没有优惠券
          _this6.couponCurrentDeductionPrice = res.data.data.couponCurrentDeductionPrice; //优惠券当前优惠金额
          _this6.couponNextDeductionPrice = res.data.data.couponNextDeductionPrice; //优惠券下一级优惠金额
          _this6.couponNeedAddPrice = res.data.data.couponNeedAddPrice; //参与下一级优惠金额补充金额
          _this6.couponId = res.data.data.couponId; //优惠券id
          _this6.couponType = res.data.data.couponType; // 优惠券类型
          _this6.couponEndTime = res.data.data.couponEndTime; // 优惠券过期时间
          //判断托运客户是否满足500
          if (res.data.data.customerDto != null) {
            _this6.userInfo.name = res.data.data.customerDto.name;
            _this6.userInfo.num = res.data.data.customerDto.account;
            _this6.userInfo.address = (res.data.data.customerDto.provinceName || "") + (res.data.data.customerDto.cityName || "") + (res.data.data.customerDto.districtName || "") + (res.data.data.customerDto.detail || "");
            _this6.userInfo.userId = res.data.data.customerDto.companyId;
            _this6.isInvoice = false;
            _this6.getInvoice();
            // 是供应商用户，获取收货地址、发票信息
            _this6.getShippingAddress(_this6.userInfo.userId, 1);
            _this6.getInvoiceList(_this6.userInfo.userId);
            _this6.getPayType(_this6.userInfo.userId);
            _this6.isShowInfoList = false;
          }

          // 如果没有数据，就返回到购物车列表
          if (_this6.shoppList.length === 0) {
            _this6.$router.go(-1);
          }
          // 如果是普通用户，直接获取收货地址、发票信息
          if (Number(_this6.userIdentity) === 1) {
            var loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
            _this6.getShippingAddress(loginCompanyId);
            _this6.getInvoiceList(loginCompanyId);
          }
          // this.getBalanceAmount();
        }
        return res;
      });
    },
    // 选择代客下单客户
    option: function option(val) {
      if (val) {
        this.userInfo.name = val.name;
        this.userInfo.num = val.account;
        this.userInfo.address = val.provinceName || "" + val.cityName || "" + val.districtName || "" + val.detail || "";
        this.userInfo.userId = val.id;
      }
      this.isInvoice = false;
      this.getInvoice();
      // 是供应商用户，获取收货地址、发票信息
      this.getShippingAddress(this.userInfo.userId, 1);
      this.getInvoiceList(this.userInfo.userId);
    },
    input: function input() {
      this.getInfoList();
    },
    // 获取客户
    getInfoList: function getInfoList() {
      var _this7 = this;
      var data = {
        accountOrName: this.userName,
        page: this.current,
        pageSize: 20
      };
      this.$getHttpClient().post(_getInfoList, data).then(function (res) {
        res.data.data.list.forEach(function (item) {
          item.checked = false;
        });
        _this7.userList = res.data.data.list;
        _this7.total = res.data.data.total;
        _this7.perPage = res.data.data.pageSize;
        _this7.disSubmit = false;
        // this.userList.forEach(item => {
        //   item.label = item.name + item.account;
        // });
      });
    },
    // 获取支付方式
    getPayType: function getPayType(companyId) {
      var _this8 = this;
      this.$getHttpClient().get("".concat(validTypeList, "?companyId=").concat(companyId)).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
          var data, onlinePay, allOnlinePay, arr, _iterator2, _step2, item;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                data = response.data.data;
                if (!(data && data.length > 0)) {
                  _context6.next = 29;
                  break;
                }
                onlinePay = _this8.getOnlinePay(data);
                if (!onlinePay) {
                  _context6.next = 8;
                  break;
                }
                _context6.next = 6;
                return _this8.pullOnlinePay();
              case 6:
                allOnlinePay = _context6.sent;
                if (allOnlinePay.length === 1) {
                  onlinePay.payTypeName = allOnlinePay[0].name;
                }
              case 8:
                // 现金客户隐藏线下支付
                if (_this8.whetherCashCustomer) {
                  arr = data.filter(function (item) {
                    return item.payTypeName !== '线下支付';
                  });
                  _this8.lstPayType = arr;
                } else {
                  // 非现金客户
                  _this8.lstPayType = data;
                }
                if (_this8.payKey) {
                  _context6.next = 29;
                  break;
                }
                _this8.payKey = _this8.lstPayType[0].payType;
                // 默认选中货到付款
                _iterator2 = _createForOfIteratorHelper(_this8.lstPayType);
                _context6.prev = 12;
                _iterator2.s();
              case 14:
                if ((_step2 = _iterator2.n()).done) {
                  _context6.next = 21;
                  break;
                }
                item = _step2.value;
                if (!(item.payType === "OFFLINE")) {
                  _context6.next = 19;
                  break;
                }
                _this8.payKey = item.payType;
                return _context6.abrupt("break", 21);
              case 19:
                _context6.next = 14;
                break;
              case 21:
                _context6.next = 26;
                break;
              case 23:
                _context6.prev = 23;
                _context6.t0 = _context6["catch"](12);
                _iterator2.e(_context6.t0);
              case 26:
                _context6.prev = 26;
                _iterator2.f();
                return _context6.finish(26);
              case 29:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[12, 23, 26, 29]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 获取运费
    getFreight: function getFreight() {
      var data = {
        addressid: this.addressId,
        distributionWay: this.giveKey
      };
      this.$getHttpClient().post(orderFrank, data).then();
    },
    // 获取配送方式
    getDistributionMode: function getDistributionMode() {
      var _this9 = this;
      this.$getHttpClient().get(distributionWay).then(function (res) {
        _this9.giveList = res.data.data;
        if (!_this9.giveKey) {
          _this9.giveKey = _this9.giveList[0].key;
        }
      });
    },
    // 获取发票抬头列表
    getInvoiceList: function getInvoiceList(loginCompanyId) {
      var _this10 = this;
      // let loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
      this.$getHttpClient().get(invoiceList + "?companyId=" + loginCompanyId).then(function (res) {
        _this10.invoiceList = res.data.data;
      });
    },
    // 设置收货地址为默认收货地址
    toDefault: function toDefault(item) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(Number(item.defaultStatus) === 1)) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              _this11.$getHttpClient().get(setAddressDefault + "?id=" + item.id).then(function (res) {
                if (res.data.code === "200") {
                  var loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
                  _this11.getShippingAddress(loginCompanyId);
                }
              });
              _context7.next = 5;
              return _this11.savePreOrder();
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 获取收货地址
    getShippingAddress: function getShippingAddress(loginCompanyId) {
      var _this12 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // let loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
      this.$getHttpClient().get(addressList + "?companyId=" + loginCompanyId).then(function (res) {
        var arr = res.data.data || [];
        _this12.addressList = arr;
        if (!_this12.addressId) {
          _this12.addressId = _this12.addressList.length > 0 ? _this12.addressList[0].id : "";
        }
        if (type && arr.length) {
          _this12.addressId = _this12.addressList[0].id;
        }
      });
    },
    // 点击收货地址，暂存一下
    getAddressId: function getAddressId(id) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this13.addressId = id;
              _context8.next = 3;
              return _this13.savePreOrder();
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 是否开票事件,置空数据
    getInvoice: function getInvoice() {
      this.invoiceForm = {
        invoiceTitle: null,
        //发票抬头
        num: "",
        //纳税人识别号
        invoiceType: 1,
        //开票方式
        remarks: ""
      };
    },
    // 选择支付方式
    clickPayType: function clickPayType(index) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this14.payKey = index;
              _context9.next = 3;
              return _this14.savePreOrder(_this14.isBalance ? 1 : 2);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    // 选择配送方式
    clickGiveType: function clickGiveType(key) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this15.giveKey = key;
              _context10.next = 3;
              return _this15.savePreOrder();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // 发票抬头事件
    getInvoiceTitle: function getInvoiceTitle(val) {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this16.invoiceList.forEach(function (item) {
                if (item.id === val) {
                  _this16.invoiceForm.num = item.taxNumber;
                }
              });
              _this16.invoiceForm.invoiceTitle = val;
              _context11.next = 4;
              return _this16.savePreOrder();
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    // 跳转发票抬头管理
    toInvoiceList: function toInvoiceList() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var result;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this17.savePreOrder();
            case 2:
              result = _context12.sent;
              if (result) {
                _this17.$router.push({
                  path: "/user-center/invoice"
                });
              }
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    // 跳转收货地址管理
    toAddressList: function toAddressList() {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var result;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this18.savePreOrder();
            case 2:
              result = _context13.sent;
              if (result) {
                _this18.$router.push({
                  path: "/user-center/address"
                });
              }
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    // 查看更多
    toLookMore: function toLookMore() {
      this.isMore = !this.isMore;
    },
    // 返回购物车
    toBack: function toBack(flag, num, val) {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var dotData, res_2;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              //返回购物车按钮埋点
              dotData = {
                "clientType": "PC",
                "version": "1.1",
                "component": "returnstocartdocumentdoc"
              };
              _context14.next = 3;
              return _this19.$getHttpClient().post("/pjyy-deepexi-collect-center/api/v1/collect", {
                body: JSON.stringify(dotData)
              });
            case 3:
              res_2 = _context14.sent;
              setTimeout(function () {
                _this19.$router.push({
                  name: "cartList",
                  params: {
                    isScrollTo: flag
                  }
                });
              }, 300);
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    //定时查询创建订单进度
    getOrderProgress: function getOrderProgress() {
      var _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var response;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this20.nums = _this20.nums + 1;
              if (_this20.nums === 30) {
                _this20.isComplete = true;
              }
              if (!(_this20.nums > 30)) {
                _context15.next = 4;
                break;
              }
              return _context15.abrupt("return");
            case 4:
              _context15.next = 6;
              return _this20.$getHttpClient({
                useSpinner: false
              }).get(orderProgress + "?uuid=" + _this20.uniqueToken + "&isComplete=" + _this20.isComplete + "&num=" + _this20.nums);
            case 6:
              response = _context15.sent;
              if (response.data.code === "200") {
                if (_this20.isShowprogress) {
                  if (response.data.data.type === 1) {
                    _this20.orderPercent = parseInt(response.data.data.progress);
                    if (response.data.data.progress === -1) {
                      _this20.$buefy.toast.open("下单失败");
                      _this20.uniqueToken = _this20.guid(20);
                      _this20.orderPercent = 3;
                      _this20.nums = 0;
                      _this20.isComplete = false;
                      _this20.isShowprogress = false;
                      _this20.orderProgress = false;
                      clearInterval(orderTimer);
                      console.log("type=1清除定时器");
                    }
                  } else if (response.data.data.type === 2) {
                    _this20.nums = 0;
                    _this20.isComplete = false;
                    _this20.orderProgress = false;
                    _this20.isShowprogress = false;
                    clearInterval(orderTimer);
                    console.log("type=2清除定时器");
                    // 线上支付->支付页面
                    if (_this20.payKey === "ONLINE") {
                      _this20.$router.replace({
                        name: "payMent",
                        params: {
                          orderId: response.data.data.ocOrderPlaceVO.orderNumber
                        }
                      });
                    } else {
                      // 线下支付
                      _this20.$router.replace({
                        name: "payResult",
                        params: {
                          payType: "offline",
                          orderId: response.data.data.ocOrderPlaceVO.orderNumber
                        }
                      });
                    }
                  } else if (response.data.data.type === 3) {
                    _this20.nums = 0;
                    _this20.isComplete = false;
                    _this20.orderProgress = false;
                    _this20.isShowprogress = false;
                    clearInterval(orderTimer);
                    console.log("type=3清除定时器,进度条有JSON对象的异常");
                    _this20.isErrorShow = true;
                    _this20.errorData = response.data.data.abnormalOrderLineForm;
                    _this20.errorBox = false;
                  } else if (response.data.data.type === 4) {
                    _this20.nums = 0;
                    _this20.isComplete = false;
                    _this20.orderProgress = false;
                    _this20.isShowprogress = false;
                    clearInterval(orderTimer);
                    _this20.isErrorShow = true;
                    _this20.orderErrorMsg = response.data.data.msg;
                    _this20.errorBox = true;
                    console.log("type=4清除定时器,进度条有JSON对象的异常");
                  }
                }
              }
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    //无视异常继续提交
    enterOrder: function enterOrder(id) {
      var _this21 = this;
      var URL = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/confirmSubmission/" + id;
      this.$getHttpClient({
        useSpinner: true
      }).post(URL).then(function (res) {
        _this21.orderProgress = false;
        // 线上支付->支付页面
        if (_this21.payKey === "ONLINE") {
          _this21.$router.replace({
            name: "payMent",
            params: {
              orderId: res.data.data.orderNumber
            }
          });
        } else {
          // 线下支付
          _this21.$router.replace({
            name: "payResult",
            params: {
              payType: "offline",
              orderId: res.data.data.orderNumber
            }
          });
        }
      });
    },
    // to支付
    toPay: function toPay() {
      var _this22 = this;
      if (timer) {
        clearInterval(timer);
      }
      this.disSubmit = true;
      // 处理收货地址参数
      var addressObj = {};
      this.addressList.forEach(function (item) {
        if (_this22.addressId === item.id) {
          addressObj.userName = item.consignee;
          addressObj.phoneNumber = item.consigneePhone;
          addressObj.province = item.province;
          addressObj.provinceName = item.provinceName;
          addressObj.distributionAddr = item.provinceName + item.cityName + item.districtName + item.addreDetail;
        }
      });
      // 获取发票抬头名称
      var invoiceObj = {
        invoiceIdentify: this.invoiceForm.num,
        invoiceType: this.invoiceForm.invoiceType,
        invoiceRemark: this.invoiceForm.remarks
      };
      this.invoiceList.forEach(function (item) {
        if (item.id === _this22.invoiceForm.invoiceTitle) {
          invoiceObj.invoiceName = item.title;
        }
      });
      if (!this.isInvoice) {
        invoiceObj = {};
      }
      // 接口入参
      // userIdentity
      var data = _objectSpread(_objectSpread(_objectSpread({}, addressObj), {}, {
        uniqueToken: this.uniqueToken,
        payType: this.payKey,
        distributionWay: this.giveKey,
        invoice: this.isInvoice ? 1 : 2
      }, invoiceObj), {}, {
        orderWay: 1,
        supplierId: this.userIdentity,
        //用户身份（1普通用户，2供应商）
        deliveryId: this.userInfo.userId,
        deliverName: this.userInfo.name,
        balanceAmount: this.balanceAmount,
        checkBalance: this.isBalance,
        givePhone: this.isgivePhone ? 1 : 0,
        checkUseCoupon: this.useCoupon,
        //是否使用优惠券
        couponId: this.couponId,
        //优惠券id
        couponType: this.couponType //优惠券类型
      });
      if (this.totalBalanceAmountdd > 0) {
        if (this.isBalance || this.isuse) {
          this.paymoneey(saveOrder, data);
          this.isShowprogress = true;
          this.orderProgress = true;
          orderTimer = setInterval(function () {
            _this22.getOrderProgress();
          }, 1000);
        } else {
          this.showtx = true;
        }
      } else {
        this.paymoneey(saveOrder, data);
        this.isShowprogress = true;
        this.orderProgress = true;
        orderTimer = setInterval(function () {
          _this22.getOrderProgress();
        }, 1000);
      }
    },
    paymoneey: function paymoneey(saveOrder, data) {
      var _this23 = this;
      this.$getHttpClient({
        useSpinner: false
      }).post(saveOrder, data).then(function (res) {
        _this23.isShowprogress = false;
        _this23.orderProgress = false;
        clearInterval(orderTimer);
        console.log("返回成功清除定时器");
        if (res.data.code == '500') {
          _this23.$buefy.toast.open(res.data.msg);
        }
        if (res.data.code == "200") {
          if (res.data.data) {
            if (res.data.data.tip) {
              _this23.isBalanceFlag = true;
              _this23.disSubmit = false;
              _this23.balanceAmount = res.data.data.balanceAmount;
              _this23.balanceMsg = res.data.msg;
              return;
            }
          }
          if (typeof res.data.payload != 'undefined') {
            if (res.data.payload.statusCode === 1) {
              _this23.isErrorShow = true;
              _this23.errorData = res.data.payload;
              _this23.errorBox = false;
            } else if (res.data.payload.statusCode === 2) {
              _this23.isErrorShow = true;
              _this23.orderErrorMsg = res.data.payload.message;
              _this23.errorBox = true;
              _this23.isMeet = true;
            } else if (res.data.payload.statusCode === 3) {
              _this23.isErrorShow = true;
              _this23.errorBox = true;
              _this23.isMeet = false;
            } else if (res.data.payload.statusCode === 4) {
              _this23.isErrorShow = true;
              _this23.errorBox = true;
              _this23.isMeet = false;
              _this23.isMeetTwo = true;
            } else if (res.data.payload.statusCode === 5) {
              _this23.arrearsData = res.data.payload;
              _this23.userArrears = true;
            }
          }
          if (!res.data.data && typeof res.data.payload == 'undefined') {
            _this23.$buefy.toast.open(res.data.msg);
          }
          if (res.data.data) {
            // 线上支付->支付页面
            if (_this23.payKey === "ONLINE") {
              _this23.$router.replace({
                name: "payMent",
                params: {
                  orderId: res.data.data.orderNumber
                }
              });
            } else {
              // 线下支付
              _this23.$router.replace({
                name: "payResult",
                params: {
                  payType: "offline",
                  orderId: res.data.data.orderNumber
                }
              });
            }
          }
        }
        if (res.data.code !== "200") {
          var th = _this23;
          th.nums = 0;
          th.orderPercent = 3;
          timer = setInterval(function () {
            th.disSubmit = false;
          }, 5000);
          return;
        }
      }).catch(function () {
        var th = _this23;
        timer = setInterval(function () {
          th.disSubmit = false;
        }, 5000);
        return;
        // this.isShowprogress = false;
        // this.orderProgress = false;
        // clearInterval(orderTimer);
        // console.log("进入异常清除定时器");
        // this.nums = 0;
        // this.orderPercent = 3;
      });
    },
    //不使用的时候isBalance为false 不检查红包使用情况
    submit_nouse: function submit_nouse() {
      this.isuse = true;
      this.showtx = false;
      this.disSubmit = false;
      this.isBalance = false;
      this.toPay();
    },
    //使用的时候isBalance为true 再次检查红包使用情况
    submit_use: function submit_use() {
      this.showtx = false;
      this.disSubmit = false;
      this.isBalance = true;
      this.toPay();
    },
    // 点击选择客户
    showInfoList: function showInfoList() {
      this.isShowInfoList = true;
    },
    // 客户查询
    searchName: function searchName() {
      this.current = 1;
      this.getInfoList();
    },
    // 重置
    resetName: function resetName() {
      this.userName = "";
      this.getInfoList();
    },
    // 选择客户
    selectUser: function selectUser(item) {
      this.userList.forEach(function (i) {
        i.checked = false;
      });
      item.checked = true;
      this.userContent = item;
    },
    //重新选择客户
    cheangeKehu: function cheangeKehu() {
      this.isErrorShow = false;
      this.isMeet = true;
      this.userInfo.name = '';
      this.userInfo.num = '';
      this.userInfo.address = '';
      this.userInfo.userId = '';
    },
    //确定选择的客户
    sureSelect: function sureSelect() {
      var _this24 = this;
      var val = this.userContent;
      if (!this.userContent.name) {
        this.$buefy.toast.open({
          message: "请选择客户",
          type: "is-danger"
        });
        return;
      } else {
        var url = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/findPreOrderShippingCustomers";
        this.$getHttpClient().post(url, {
          companyId: val.companyId,
          name: val.name,
          account: val.account,
          uuid: this.$route.params.id,
          provinceName: val.provinceName,
          cityName: val.cityName,
          districtName: val.districtName,
          detail: val.detail
        }).then(function (res) {
          if (res.data.code == 200) {
            if (res.data.data) {
              _this24.userInfo.name = val.name;
              _this24.userInfo.num = val.account;
              _this24.userInfo.address = (val.provinceName || "") + (val.cityName || "") + (val.districtName || "") + (val.detail || "");
              _this24.userInfo.userId = val.companyId;
              _this24.isInvoice = false;
              _this24.getInvoice();
              _this24.findPreOrder();
              // 是供应商用户，获取收货地址、发票信息
              _this24.getShippingAddress(_this24.userInfo.userId, 1);
              _this24.getInvoiceList(_this24.userInfo.userId);
              _this24.getPayType(_this24.userInfo.userId);
              _this24.isShowInfoList = false;
            } else {
              _this24.isErrorShow = true;
              _this24.errorBox = true;
              _this24.isMeet = false;
            }
          }
        });
      }
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getInfoList();
    },
    //获取余额抵扣金额
    getBalanceAmount: function getBalanceAmount() {
      var _this25 = this;
      var url = "/pjyy-deepexi-order-center/api/v1/order/OcOrder/getBalanceAmount?realPayAmount=".concat(this.totalForm.allTotal);
      this.$getHttpClient().post(url).then(function (res) {
        _this25.balanceAmount = res.data.data;
      });
    },
    // 确定抵扣
    sureBalance: function sureBalance() {
      this.toPay();
    },
    //生成唯一标识
    guid: function guid() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
      var firstU = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var radix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
      var uuid = [];
      radix = radix || chars.length;
      if (len) {
        // 如果指定uuid长度,只是取随机的字符,0|x为位运算,能去掉x的小数位,返回整数位
        for (var i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
      } else {
        var r;
        // rfc4122标准要求返回的uuid中,某些位为固定的字符
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (var _i = 0; _i < 36; _i++) {
          if (!uuid[_i]) {
            r = 0 | Math.random() * 16;
            uuid[_i] = chars[_i == 19 ? r & 0x3 | 0x8 : r];
          }
        }
      }
      // 移除第一个字符,并用u替代,因为第一个字符为数值时,该guuid不能用作id或者class
      if (firstU) {
        uuid.shift();
        return 'u' + uuid.join('');
      } else {
        return uuid.join('');
      }
    }
  }
};